import axios from '@/libs/api.request'

export const getStockOutList = ({ start, end, kw, page, perPage }) => {
  const data = {
    start,
    end,
    kw,
    page,
    perPage
  }
  return axios.request({
    url: 'stockout/list',
    data,
    method: 'post'
  })
}

export const getStockOut = (id) => {
  return axios.request({
    url: 'stockout/' + id,
    method: 'get'
  })
}

export const addStockOut = (dt, customerId, items) => {
  const data = {
    dt,
    'customer_id': customerId,
    items
  }
  return axios.request({
    url: 'stockout/add',
    data,
    method: 'post'
  })
}

export const deleteStockOut = (id) => {
  return axios.request({
    url: 'stockout/' + id,
    method: 'delete'
  })
}

export const getNewNo = (dt) => {
  return axios.request({
    url: 'stockout/newno/' + dt,
    method: 'get'
  })
}

export const getStockOutItemList = (soId) => {
  return axios.request({
    url: 'stockoutitem/list/' + soId,
    method: 'get'
  })
}
